import { useTranslation } from 'react-i18next';
import { Card, Input } from '../common';
import { usePricingStore } from '../../stores/pricingStore';

export function ManualFCRInput() {
  const { t } = useTranslation();
  const { manualTargetFCR, setManualTargetFCR } = usePricingStore();

  const handleManualFCRChange = (value: string) => {
    const numValue = parseFloat(value);
    if (value === '' || isNaN(numValue)) {
      setManualTargetFCR(null);
    } else {
      setManualTargetFCR(numValue);
    }
  };

  return (
    <Card title={t('sidebar.manualFCRTitle')}>
      <Input
        label={t('sidebar.manualFCRLabel')}
        type="number"
        step="0.001"
        value={manualTargetFCR?.toString() ?? ''}
        onChange={(e) => handleManualFCRChange(e.target.value)}
        helperText={t('sidebar.manualFCRHelper')}
        placeholder={t('sidebar.manualFCRPlaceholder')}
      />
    </Card>
  );
}
